import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AppService } from '@root/app.service';

type CN_URL = string;
type EN_URL = string;

type InputUrls = [ CN_URL, EN_URL ];

@Directive({
  selector: '[hostI18nImageSwitcher]'
})
export class I18nImageSwitcherDirective implements AfterViewInit {
  @Input() urls: InputUrls;
  get isInternational() {
    return this.app.app.international;
  }
  constructor(
    private el: ElementRef,
    private render: Renderer2,
    private app: AppService
  ) { }

  ngAfterViewInit(): void {
    this.switchImageUrl();
  }

  private switchImageUrl() {
    if (!this.urls) {
      return;
    }
    const url = this.isInternational ? this.urls[1] : this.urls[0];
    this.render.setAttribute(
      this.el.nativeElement,
      'src',
      url
    );
  }

}
